<template>
  <el-dropdown-item v-bind="$attrs">
    <slot />
  </el-dropdown-item>
</template>
<script>
export default {
  name: 'RtDropdownItem',
  data () {
    return {};
  }
};
</script>



// WEBPACK FOOTER //
// rtDropdownItem.vue?7ee2b4f8